export const collection = {
    noData: 'Bạn chưa sở hữu NFT nào.',
    title: 'Bộ sưu tập của bạn',
};
